import { createContext, useContext } from 'react';

/**
 * True when an ancestor owns the LiveKit connection for this subtree.
 *
 * Preview components open their own room when used standalone. Inside a shared room they must not,
 * or the browser joins the same room once per visible preview and every preview that unmounts —
 * a cue with no layers, a closed picker — shows up as a participant leaving mid-show.
 */
const SharedLiveKitRoomContext = createContext(false);

export const SharedLiveKitRoomContextProvider = SharedLiveKitRoomContext.Provider;

export function useHasSharedLiveKitRoom(): boolean {
  return useContext(SharedLiveKitRoomContext);
}
